import { FC } from "react";
import { toAbsoluteUrl } from "../../../../_metronic/helpers";
import { GetStoreIfo, usePermissionChecker } from "../../../hooks/PermissionChecker";
import { BUSINESS_TYPE_HOUSE_HOLD_1, BUSINESS_TYPE_HOUSE_HOLD_2, BUSINESS_TYPE_HOUSE_HOLD_3, BUSINESS_TYPE_HOUSE_HOLD_4, LIST_PERMISSIONS } from "../../../constants/common";

interface Props {
    changeTab: (tab: string) => void
    handleExport: (accountType: string) => void
    businessType: number
}
const IndexAccount: FC<Props> = ({changeTab, handleExport, businessType}) => {
    const { hasPermission } = usePermissionChecker();
    const showCashBook = hasPermission(LIST_PERMISSIONS.ACCOUNT_BOOKS_CASH) && businessType !== BUSINESS_TYPE_HOUSE_HOLD_1 
    const showBankBook = hasPermission(LIST_PERMISSIONS.ACCOUNT_BOOKS_BANK) && businessType !== BUSINESS_TYPE_HOUSE_HOLD_1 
    const showSaleBook = hasPermission(LIST_PERMISSIONS.ACCOUNT_BOOKS_SALE)
    const showWarehouseBook = hasPermission(LIST_PERMISSIONS.ACCOUNT_BOOKS_WAREHOUSE) && businessType !== BUSINESS_TYPE_HOUSE_HOLD_1 
    const showExpensesBook = hasPermission(LIST_PERMISSIONS.ACCOUNT_BOOKS_EXPENSE) && businessType !== BUSINESS_TYPE_HOUSE_HOLD_1 
    const showTaxBook = hasPermission(LIST_PERMISSIONS.ACCOUNT_BOOKS_TAX) && businessType !== BUSINESS_TYPE_HOUSE_HOLD_1 
    const showPayrollBook = hasPermission(LIST_PERMISSIONS.ACCOUNT_BOOKS_PAYROLL) && businessType !== BUSINESS_TYPE_HOUSE_HOLD_1 
    
    return <div className="row">
        <div className="col-12  mt-3">
            <div className="btns-group">
                {/* {businessType === BUSINESS_TYPE_HOUSE_HOLD_1 && ( */}
                    <button onClick={() => handleExport('s1a')} className="btn btn-primary my-1 mx-1">
                        <i className="fa fa-file-export"></i> S1a-HKD
                    </button>
                {/* )} */}
                {/* {businessType === BUSINESS_TYPE_HOUSE_HOLD_2 && ( */}
                    <button onClick={() => handleExport('s2a')} className="btn btn-primary my-1 mx-1">
                        <i className="fa fa-file-export"></i> S2a-HKD
                    </button>
                {/* )}
                {(businessType === BUSINESS_TYPE_HOUSE_HOLD_3 || businessType === BUSINESS_TYPE_HOUSE_HOLD_4) && ( */}
                    <>
                        <button onClick={() => handleExport('s2b')} className="btn btn-primary my-1 mx-1">
                            <i className="fa fa-file-export"></i> S2b-HKD
                        </button>
                        <button onClick={() => handleExport('s2c')} className="btn btn-primary my-1 mx-1">
                            <i className="fa fa-file-export"></i> S2c-HKD
                        </button>
                        <button onClick={() => handleExport('s2d')} className="btn btn-primary my-1 mx-1">
                            <i className="fa fa-file-export"></i> S2d-HKD
                        </button>
                        <button onClick={() => handleExport('s2e')} className="btn btn-primary my-1 mx-1">
                            <i className="fa fa-file-export"></i> S2e-HKD
                        </button>
                    </>
                {/* )} */}
                <button onClick={() => handleExport('s3a')} className="btn d-none btn-primary my-1 mx-1">
                    <i className="fa fa-file-export"></i> S3a-HKD
                </button>
            </div>
        </div>
        { showCashBook && (
            <div className="col-6 col-md-6 col-lg-4">
                <div onClick={() => changeTab('cashbook')} className='card mt-3 cursor-pointer'>
                    <div className='card-body text-center'>
                        <h2 className="">Sổ Quỹ TM</h2>
                        <img style={{maxWidth: '100%'}} src={toAbsoluteUrl('/media/account-books/so-tien-mat.png')} alt='' />
                        <p className="fs-2">Theo dõi thu chi tiền mặt</p>
                    </div>
                </div>
            </div>
        )}
        { showBankBook && (
            <div className="col-6 col-md-6 col-lg-4">
                <div onClick={() => changeTab('bankbook')} className='card mt-3 cursor-pointer'>
                    <div className='card-body text-center'>
                        <h2 className="">Sổ Ngân Hàng</h2>
                        <img style={{maxWidth: '100%'}} src={toAbsoluteUrl('/media/account-books/so-ngan-hang.png')} alt='' />
                        <p className="fs-2">Sổ chi tiết tiền gửi ngân hàng</p>
                    </div>
                </div>
            </div>
        )}
        { showSaleBook && (
            <div className="col-6 col-md-6 col-lg-4">
                <div onClick={() => changeTab('sales')} className='card mt-3 cursor-pointer'>
                    <div className='card-body text-center'>
                        <h2 className="">Sổ Bán Hàng</h2>
                        <img style={{maxWidth: '100%'}} src={toAbsoluteUrl('/media/account-books/so-ban-hang.png')} alt='' />
                        <p className="fs-2">Sổ chi tiết doanh thu bán hàng</p>
                    </div>
                </div>
            </div>
        )}
        { showWarehouseBook && (
            <div className="col-6 col-md-6 col-lg-4">
                <div onClick={() => changeTab('warehouses')} className='card mt-3 cursor-pointer'>
                    <div className='card-body text-center'>
                        <h2 className="">Sổ Kho</h2>
                        <img style={{maxWidth: '100%'}} src={toAbsoluteUrl('/media/account-books/so-kho.png')} alt='' />
                        <p className="fs-2">Sổ tổng hợp tồn kho hàng hóa</p>
                    </div>
                </div>
            </div>
        )}
        { showExpensesBook && (
            <div className="col-6 col-md-6 col-lg-4">
                <div onClick={() => changeTab('expenses')} className='card mt-3 cursor-pointer'>
                    <div className='card-body text-center'>
                        <h2 className="">Sổ Chi Phí SXKD</h2>
                        <img style={{maxWidth: '100%'}} src={toAbsoluteUrl('/media/account-books/so-chi-phi.png')} alt='' />
                        <p className="fs-2">Sổ chi phí sản xuất, kinh doanh</p>
                    </div>
                </div>
            </div>
        )}
        { showTaxBook && (
            <div className="col-6 col-md-6 col-lg-4">
                <div onClick={() => changeTab('taxbook')} className='card mt-3 cursor-pointer'>
                    <div className='card-body text-center'>
                        <h2 className="">Sổ Thuế</h2>
                        <img style={{maxWidth: '100%'}} src={toAbsoluteUrl('/media/account-books/so-thue.png')} alt='' />
                        <p className="fs-2">Theo dõi nghĩa vụ thuế, nộp NSNN</p>
                    </div>
                </div>
            </div>
        )}
        { showPayrollBook && (
            <div className="col-6 col-md-6 col-lg-4">
                <div onClick={() => changeTab('payroll')} className='card mt-3 cursor-pointer'>
                    <div className='card-body text-center'>
                        <h2 className="">Sổ Lương</h2>
                        <img style={{maxWidth: '100%'}} src={toAbsoluteUrl('/media/account-books/so-luong.png')} alt='' />
                        <p className="fs-2">Theo dõi thanh toán lương & BHXH</p>
                    </div>
                </div>
            </div>
        )}
    </div>
}

export default IndexAccount;